import { TreeDropdown as AntdTreeDropdown } from "@empglabs/backoffice-ui-kit"

export const TreeDropdown = props => {
  return <AntdTreeDropdown {...props} />
}
